/* import { cloneNavTreeWithDepthLimit } from "./navigation-utils.js";

export default function initFooterNav(state) {

  console.log("INIT Footer Nav RUNNING");

  const footer = document.querySelector("#footer-nav");
  if (!footer) return;

  const limitedTree = cloneNavTreeWithDepthLimit(state.tree, 2);

  limitedTree.forEach(section => {

    const col = document.createElement("div");
    col.className = "col-md-4 col-lg-3 mb-4";

    let html = `
      <div class="sz-footer-nav__column">
        <div class="sz-footer-nav__heading">
          <a href="${section.url}"
             class="${state.path.includes(section.url) ? "is-active" : ""}">
            ${section.label}
          </a>
        </div>
    `;

    if (section.children?.length) {

      html += `<ul class="sz-footer-nav__list">`;

      section.children.forEach(item => {
        html += `
          <li>
            <a href="${item.url}"
               class="${state.path.includes(item.url) ? "is-active" : ""}">
              ${item.label}
            </a>
          </li>
        `;
      });

      html += `</ul>`;
    }

    html += `</div>`;

    col.innerHTML = html;
    footer.appendChild(col);
  });
} */
import { cloneNavTreeWithDepthLimit, createNavLink } from "./navigation-utils.js";

export default function initFooterNav(state) {
  console.log("INIT Footer Nav RUNNING");

  const footer = document.querySelector("#footer-nav");
  if (!footer) return;

  const limitedTree = cloneNavTreeWithDepthLimit(state.tree, 2);

  footer.replaceChildren();

  limitedTree.forEach((section) => {
    const col = document.createElement("div");
    col.className = "col-md-4 col-lg-3 mb-4";

    const column = document.createElement("div");
    column.className = "sz-footer-nav__column";

    const heading = document.createElement("div");
    heading.className = "sz-footer-nav__heading";

    const headingLink = createNavLink({
      url: section.url,
      label: section.label,
      isActive: state.path.includes(section.url),
    });

    heading.appendChild(headingLink);
    column.appendChild(heading);

    if (section.children?.length) {
      const ul = document.createElement("ul");
      ul.className = "sz-footer-nav__list";

      section.children.forEach((item) => {
        const li = document.createElement("li");

        const link = createNavLink({
          url: item.url,
          label: item.label,
          isActive: state.path.includes(item.url),
        });

        li.appendChild(link);
        ul.appendChild(li);
      });

      column.appendChild(ul);
    }

    col.appendChild(column);
    footer.appendChild(col);
  });
}